const RULES = {
  event: 'favoriteCollectionClicked',
  required: ['action']
};
const EVENTS = {
  renameCollection: {
    action: 'RENAME COLLECTION'
  },
  shareCollection: {
    action: 'SHARE COLLECTION'
  },
  createCollection: {
    action: 'CREATE COLLECTION'
  },
  deleteCollection: {
    action: 'DELETE COLLECTION'
  }
};
const create = (event, data = {}) => {
  const {
    action,
    collection: {
      id: collectionId,
      favoriteListingIds,
      name = ''
    } = {}
  } = data;
  const listingIds = favoriteListingIds || [];
  if (!EVENTS[event]) {
    const allowedEvents = Object.keys(EVENTS).join(', ');
    throw new TypeError(`Only these events are compatible with this schema: ${allowedEvents}`);
  }
  return {
    favoriteCollectionClicked: {
      action,
      collectionId: (collectionId || '').toString(),
      listingIds,
      listingCount: listingIds.length,
      name,
      ...EVENTS[event]
    },
    ...data,
    event: 'favoriteCollectionClicked'
  };
};
var favoriteCollectionClicked = {
  create,
  RULES
};

export { favoriteCollectionClicked as default };
